module.exports = __webpack_public_path__ + "img/fun-3.9de70868.png";